export const artistsdata = [
  {
    id: 1,
    web: "demimulla",
    name: "Demi Mulla",
    image: "https://d1g9iww9o5ioh1.cloudfront.net/artists_page/demimulla.webp",
    description: (
      <>
        Raised in South London, Streatham. Artist Demi Mulla incorporates
        Dancehall, Afrobeats and R&B. <br /> <br /> Demi Mulla intends to take
        the world by storm with unique melodic flows and blending genres from
        across the board.
      </>
    ),
    apple: "https://music.apple.com/cz/artist/demi-mulla/1540693020",
    spotify:
      "https://open.spotify.com/artist/3sjh5nINlAnwcXW6ugUzVH?si=acQeHRQJSraXQbx3I7ioVg",
    soundcloud: "https://on.soundcloud.com/vEam13YLutoNbguo8",
    instagram: "https://www.instagram.com/demimulla/",
    tiktok: "https://www.tiktok.com/@demimulla?_t=ZG-8t5zcMJt2xN&_r=1",
    twitter: "https://x.com/demimulla",
  },
  {
    id: 2,
    web: "gwarmz",
    name: "Gwamz",
    image: "https://d1g9iww9o5ioh1.cloudfront.net/artists_page/gwarmz.webp",
    description: (
      <>
        Gwamz is a 23-year-old artist hailing from South West London. Gwamz had
        a passion for football from a young age but found his interests shifting
        toward computers, web design, and music. <br /> <br />
        Raised by his Ghanaian mother, Gwamz’s love for music was cultivated in
        the church where he plays the drums week in, week out. He was first
        introduced to production in school where his music teacher, Miss Mole,
        played a significant role in nurturing his new-found passion. Now,
        Gwamz’s prodigious talent in meticulous songwriting and beat production
        have made him a highly anticipated artist.
        <br /> <br /> Gwamz describes himself as an ‘Afro-fusion’ artist
        twisting together elements of Afrobeats, Rap, Grime, and R&B. As Gwamz
        continues to grow and hone his craft, his music promises to captivate
        and inspire audiences worldwide.
      </>
    ),
    column1: (
      <>
        “To delve into the heart of Afroswing and its impact, I had the pleasure
        of sitting down for a brief interview with the talented artist Gwamz, a
        rising star in the genre making waves with his distinct sound and style.
        Coming off the success of his last single, “Last Night”, I interviewed
        the 22-year-old self-proclaimed “Afro-fusion” artist to pick his brains
        on the music scene and his overall journey to date: Brian: How did your
        artistic journey into Afroswing start? <br /> <br /> Gwamz: I started
        off as a producer, then I got into rapping. I was around 16/17 when I
        started playing around with vocals and recording audio on my laptop. I
        had no mic, so I had to bring the laptop close to my mouth to record. I
        was always good with melodies, even at my work studio. If they needed a
        melody, they would come to me. I eventually decided to stop being a
        rapper and fully commit to going down the melodic avenue, and that's how
        I ended up doing Afroswing. <br /> <br /> Brian: Are there any specific
        things you aim to achieve through your Afroswing music?
      </>
    ),
    column2: (
      <>
        Gwamz: I like to create stories in my music, so I want the people who
        listen to my songs to feel like they are the main character in the song.
        I also want them to feel positive emotions when they listen to me.
        <br /> <br />
        Brian: What advice would you give aspiring artists interested in
        pursuing a career in the Afroswing genre? <br /> <br />
        Gwamz: Be yourself, don’t copy someone else’s blueprint. What works for
        someone else may not work for you. Being true to who you are attracts
        people to your sound that like you for you. So, the best thing to do is
        to find your own lane and hone your sound. <br /> <br />
        Brian: How do you feel about the representation of Afroswing in
        mainstream media and its recognition within the music industry?{" "}
      </>
    ),
    column3: (
      <>
        Gwamz: It’s definitely growing, and I feel like it's gonna be bigger
        than anything else in the next ⅔ years. In the past year or so, we have
        seen how much more global Afroswing has become, and that's also due to
        the rising global popularity of Afrobeats. Next year, summer is going to
        be amazing for the Afro-swing scene, and there are a few people to look
        out for, such as Jaybiz and Cxrno. <br /> <br />
        Brian: What plans do you have for music in the coming months?
        <br /> <br />
        Gwamz: The plan is to explore a bit more. Honestly, I want my sound to
        be heard globally, so it’s a process. I don’t want to be dropping too
        much, as I take every song release seriously. You’ve got to stand out
        with your marketing especially.” -Brian Omowumi Afroswing: The Rise, The
        Decline, The Revival?{" "}
      </>
    ),
    apple: "https://music.apple.com/ga/artist/gwamz/1327973142?l=en-GB",
    spotify:
      "https://open.spotify.com/artist/5asNjXXCZBu2NfJDarWlRR?si=nQzIkVxkRNaWyJJ6v11PTA",
    soundcloud: "https://on.soundcloud.com/jJKnzoSrbhy6ewRv5",
    instagram:
      "https://www.instagram.com/gwamzofficial?igsh=MTJqaXZ2YnFrcWNhZw==",
    tiktok: "https://www.tiktok.com/@gwamzofficial?_t=8qb2skfB0bo&_r=1",
    twitter: "https://x.com/gwamzofficial?s=21&t=-zqnoi5XgftC8eHr9Aeu1w",
  },
  {
    id: 3,
    web: "ikemdi",
    name: "Ikemdi",
    image: "https://d1g9iww9o5ioh1.cloudfront.net/artists_page/ikemdi.webp",
    description: (
      <>
        22 year old soon-to-be Afro-fusion superstar, Ikemdi, takes his stage
        name from his more-distinguished given name; Ikemdinachi Chigozie
        Ajaero. Born in the US and raised in Nigeria, the talented songster
        moved to the UK at the age of 16, armed with his love of music and
        dreams of sharing that music with the world.
        <br /> <br />
        Encouraged by his parents to explore his musical talents, Ikemdi now
        plays up to thirteen instruments ranging from the guitar to the
        saxophone, a unique trait that has heavily contributed towards his
        musical knowledge and understanding.At the tender age of four, he was
        already playing the piano, and by fifteen, he knew that music was the
        only career choice for him.
        <br /> <br />
        With inspiration and influence from a variety of artists, from Stevie
        Wonder to Whitney Houston to Chris Brown, Ikemdi describes his sound as
        ‘Afro- fusion’ to encompass the different genres that he experiments
        with, although his main loves are Afrobeats and R & B.
      </>
    ),
    apple: "https://music.apple.com/gb/artist/ikemdi/1533739006",
    spotify:
      "https://open.spotify.com/artist/5oNBqD0hGZKC9OOcJlz7gM?si=iigevTGaS6-zv04P6kXebQ",
    soundcloud: "https://on.soundcloud.com/BnKx3Mm5fwshAF9x8",
    instagram: "https://www.instagram.com/demimulla/",
    tiktok: "https://www.tiktok.com/@ikemdii?_t=ZG-8t5zcpDIhIu&_r=1",
    twitter: "https://x.com/ikemdii?s=21",
  },
  {
    id: 4,
    web: "jaybiz",
    name: "Jay Biz",
    image: "https://d1g9iww9o5ioh1.cloudfront.net/artists_page/jaybiz.webp",
    description: (
      <>
        {" "}
        Jay Biz stands as a trailblazer in the music industry. A serendipitous
        encounter with the UK producer F1 in 2020 paved the way for the creation
        of chart-topping hits like 'Guilty Pleasures' and 'Play For Keeps,' the
        latter amassing over 10 million streams across all digital platforms.
        Hailing from Streatham Vale, London, this 22-year-old British-Ghanaian
        artist aspires to transcend the boundaries of conventional industry
        descriptors.
        <br /> <br />
        His musical journey commenced at the age of 10 when he engaged with his
        church choir, and by year 10, his passion crystallised within the
        confines of his music group, 'Krypto.' Jay Biz's dedication to his craft
        became evident as he regularly shared freestyles on Instagram, eliciting
        widespread acclaim and accumulating thousands of views. The overwhelming
        response propelled him to commit to music full-time.
        <br /> <br />
        Jay Biz's sonic palette is an intricate fusion of Afrobeats, house,
        funk, soul, and R&B. This amalgamation not only pioneers a new genre but
        promises to send ripples not only across the United Kingdom but
        globally. His commitment to crafting a sound that defies traditional
        industry norms underscores his ambition to make an indelible mark on the
        global music landscape.
      </>
    ),
    apple: "https://music.apple.com/us/artist/jay-biz/147967224",
    spotify:
      "https://open.spotify.com/artist/5H78xIcG2BFJiLMbT9vLcF?si=ZW_ejZB5SnGmLSbTv0ePww",
    soundcloud: "https://on.soundcloud.com/8eVb1fYid4FuJy8q7",
    instagram: "https://www.instagram.com/demimulla/",
    tiktok: "https://www.tiktok.com/@officialjaybiz?_t=ZG-8t5ze6cT33Z&_r=1",
    twitter: "https://x.com/officialjaybiz",
  },
  {
    id: 5,
    web: "kenz",
    name: "Kenz",
    image: "https://d1g9iww9o5ioh1.cloudfront.net/artists_page/kenz.webp",
    description: (
      <>
        Hailing from West London, with roots in Nigeria, KENZ is an
        Afro-R&B/Alté-Fusion artist who seamlessly blends traditional African
        rhythms with contemporary sounds.
        <br />
        <br />
        With a mission to communicate his thoughts and feelings through his
        music, KENZ creates a unique blend of soulful melodies and
        thought-provoking lyrics that transport listeners on a journey of
        self-discovery and introspection.
        <br />
        <br />
        His music is not just about entertainment but also a tool to connect
        with people on a deeper level and to evoke emotion. He uses his music as
        a medium to raise awareness on the issues that are important to him, but
        also to create a space for people to connect with their inner selves and
        to find solace.
        <br />
        <br />
        With a sound that is both authentic and fresh, KENZ is an artist to
        watch as he continues to push the boundaries of the Afrobeat genre,
        bridge the gap between UK and African music and further make music that
        truly feeds the soul.
      </>
    ),
    apple: "https://music.apple.com/us/artist/kenz/1515940773",
    spotify:
      "https://open.spotify.com/album/5aD8fhlyjV3mImycRCiKcO?si=K7_x8CRhQzWJBiTHQSTcqA",
    instagram: "https://www.instagram.com/demimulla/",
    tiktok: "https://www.tiktok.com/@officialkenz100?_t=ZG-8t5zjMq47zU&_r=1",
  },
  {
    id: 6,
    web: "kvngs",
    name: "Kvngs",
    image: "https://d1g9iww9o5ioh1.cloudfront.net/artists_page/kvngs.webp",
    description: (
      <>
        Kvngs is an Afro-wave artist, rapper, and producer hailing from the
        vibrant city of London. Drawing inspiration from the impressive musical
        talents of renowned Nigerian artists such as Chocolate City boys (M.I,
        Jesse Jagz) and Burna Boy, Kvngs has seamlessly crafted a unique musical
        style that bridges the gap between London's urban scene and the
        infectious rhythms of West Africa.
        <br />
        <br />
        Born in the bustling city of London, Kvngs upbringing and education took
        him back and forth between London and the culturally-rich city of
        Ibadan. It was during these formative years that he began immersing
        himself in the diverse musical cultures and histories of both regions.
        With an insatiable passion for music, he eagerly absorbed the eclectic
        sounds of the UK, including genres like grime, R&B, and house, while
        simultaneously being captivated by Nigeria's thriving Afrobeats and
        Afro-Pop scenes.
        <br />
        <br />
        Kvngs musical journey is a testament to his ability to traverse between
        worlds and effortlessly fuse different genres.His Afro-Fusion sound is
        an infectious blend of Afro-Pop, R&B, and UK street sounds, seamlessly
        interweaving rich melodies, captivating beats, and thought-provoking
        lyrics.
      </>
    ),
    apple: "https://music.apple.com/us/artist/kvngs/1391552311",
    spotify:
      "https://open.spotify.com/artist/1SxJBIJJbaj2fpni5DNoXU?si=JwxLw1vVTbqPHsj0XI3eqA",
    instagram: "https://www.instagram.com/demimulla/",
    tiktok: "https://www.tiktok.com/@kvngssound?_t=ZG-8t5zrDWU8Js&_r=1",
  },
  {
    id: 7,
    web: "mosescbg",
    name: "Moses CBG",
    image: "https://d1g9iww9o5ioh1.cloudfront.net/artists_page/mosescbg.webp",
    description: (
      <>
        ESSEX based artist MOSES CGB has become a pioneer of the sound Altè
        Fusion and is on the rise as a self made artist.
        <br /> <br />
        His sound is a fluent blend of all types of genres from the likes of
        R&B, hip hop to Afrobeats and more, all fused into the one genre.
        Stemming from an African heritage, British upbringing and constant drive
        to learn and evolve, he has been able to express his creativity through
        his skill set and ability to produce, write and engineer music. Examples
        of this are demonstrated with track releases such as INTENTIONAL, MUSE,
        SAY I!, ONCE IN A BLUE MOON & JADED
      </>
    ),
    apple: "https://music.apple.com/ie/artist/moses-cgb/1492308348",
    spotify:
      "https://open.spotify.com/artist/34WZYq9XpljqZjXi6Zv2C5?si=kZAGZrKDThW15oC5iD3D-Q",
    instagram: "https://www.instagram.com/demimulla/",
    tiktok: "https://www.tiktok.com/@mrceegb?is_from_webapp=1&sender_device=pc",
    twitter: "https://x.com/mrceegb",
  },
  {
    id: 8,
    web: "osas",
    name: "Osas",
    image: "https://d1g9iww9o5ioh1.cloudfront.net/artists_page/osas.webp",
    description: (
      <>
        Osas, an exceptionally talented artist from the vibrant streets of South
        East London, carries a deep-rooted Nigerian heritage connected to Benin
        City in Edo State.
        <br />
        <br />
        Drawing inspiration from Afrobeats and the soulful essence of R&B, Osas
        nurtured his musical talent from a young age, encouraged by family to
        share his unique voice with the world. Beginning his journey on
        SoundCloud, he quickly attracted a global audience, expanding his reach
        and resonating deeply with listeners everywhere.
        <br />
        <br />
        Through a seamless blend of velvety vocals, polished flow, and evocative
        lyrics, Osas crafts music that bridges cultures and captivates
        audiences.With a vision to redefine contemporary sound, he’s set to make
        an enduring impact, inviting all who listen to experience the depth of
        his artistry.
      </>
    ),
    apple: "https://music.apple.com/gb/artist/osas/79965542",
    spotify:
      "https://open.spotify.com/artist/4psqSKodkpuB8kIbbVl5GQ?si=7ikqudQqSTS_Qi5M8xJGtw",
    soundcloud:
      "https://soundcloud.com/osasmusic?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
    instagram: "https://www.instagram.com/demimulla/",
    tiktok:
      "https://www.tiktok.com/@osasmusic?is_from_webapp=1&sender_device=pc",
    twitter: "https://x.com/osasmusic_",
  },
];
